module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_clean", [["div",{"id":"header"},[["div",{"class":"page-width add-clearfix"},[["div",{"class":"fleft banner"},[["a",{"href":"/","class":"logo"},[["if",{"empty":"","addclass":"mc"},[["else",{"addclass":"custom"},[["img",{"src":""},[],[["siteLogo","src",true]]]]]],[["siteLogo","empty",true]]]]]]],["ul",{"class":"fleft main nmenu add-clearfix"}],["ul",{"class":"fright second nmenu add-clearfix"}]]]]],["div",{"id":"container","class":"common-content"}],["div",{"id":"footer"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/templates/layout/clean.tpl
// module id = 245
// module chunks = 2